<template>
<div class="rolesMContainer">
  <div class="mainContent" :style="styleObject">
    <div class="query">
      <el-input placeholder="请输入套餐名字" v-model="pagination.name"></el-input>
      <button class="primaryBtn" @click="search">搜索</button>
    </div>
    <div class="tableBox contentShowArea">
      <border-table :loading="rolesLoading" :tableData="roleList"  :pageSizes="[10, 20, 50]" :pages="pagination" @currentChange="handleRoleCurrentChange" @sizeChange="handleRoleSizeChange">
        <el-table-column prop="packageName" label="套餐名字" align="center"></el-table-column>
        <el-table-column prop="packageType" label="套餐类型" align="center"></el-table-column>
        <el-table-column label="套餐包含数量 (条) " prop="packageNum" align="center">
        </el-table-column>
        <el-table-column label="单价" prop="packageType" align="center">
        </el-table-column>
        <el-table-column prop="packagePrice" label="套餐价格" align="center"></el-table-column>        
        <el-table-column label="操作" align="center">
          <template #default="{row}">
            <el-button @click="handlePurchase(row)" size="small" class="edit">购买</el-button>
          </template>
        </el-table-column>
      </border-table>
    </div>
  </div>
</div>
</template>

<script>
import BorderTable from "@/components/common/BorderTable.vue";
import OneGroupCheckboxs from "@/components/common/OneGroupCheckboxs";
export default {
  components: {
    BorderTable,
    OneGroupCheckboxs
  },
  data() {
    return {
      styleObject: {
        height: ""
      },
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 10,
        total: 0,
        name: '',
      },
      tableHeight: null,
      rolesLoading: false,
      roleList: [],
    };
  },
  computed: {
    currentTreeId() {
      return this.$store.state.currentTreeId;
    },
    screenData() {
      return this.$store.state.screen;
    }
  },
  watch: {
    screenData() {
      this.tableHeight = document.body.clientHeight - 350 + "px";
    }
  },
  created() {
    this.makeheight();
    // this.tableHeightInit();
  },
  mounted() {
    this.queryRoleList();
  },
  methods: {
    search() {
      this.pagination.currentPage = 1;
      this.queryRoleList();
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      _this.tableHeight = window.innerHeight - 340;
      console.log(_this.tableHeight);
      window.onresize = () => {
        return (() => {
          _this.tableHeight = window.innerHeight - 340;
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    tableHeightInit() {
      this.tableHeight = document.body.clientHeight - 350 + "px";
    },
    queryRoleList() {
      this.rolesLoading = true;
      this.request
        .post("/front/tariff/card/query", {
          page: this.pagination.currentPage,
          pageNum: this.pagination.pageSize,
          packageName: this.pagination.name,
        })
        .then(rs => {
          if (rs.code == 200) {
            if (rs.total > 0) {
              this.roleList = rs.data
            } else {
              this.roleList = []
            }
            this.pagination.total = rs.total
          } else {}
          this.rolesLoading = false
        })
        .catch(error => {
          console.log(error)
          this.rolesLoading = false
        })
    },
    handleRoleCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage
      this.queryRoleList()
    },
    handleRoleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.currentPage = 1
      this.queryRoleList()
    },
    // 点击购买跳转页面
    handlePurchase () {
      let data = JSON.stringify(this.roleList)
      this.$router.push({
        path: "/purchase",
        query: {
          data
        },
      })
    },
  }
};
</script>

<style lang="scss" scoped>
.rolesMContainer {
  .mainContent {
    margin: 12px;
    padding: 15px 0;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;

    .query {
      padding: 0 20px 20px;
    }

    .tableBox {
      padding: 0 20px;
    }

    .edit {
      background: #327ae6;
      color: #fff;
    }

    .del {
      background: #eaa13a;
      color: #fff;
    }

    .detail {
      background: #32AC63;
      color: #fff;
    }
  }
}
</style>
<style lang="scss">
.rolesMContainer {
  .drawerWrap .el-form .el-form-item__content .el-checkbox{
    
  }
  .mainContent {
    .query {
      .el-input {
        width: 200px;
        margin-right: 10px;

        .el-input__inner {
          line-height: 36px;
          height: 36px;
        }
      }

      .el-select {
        width: 170px;
        margin-right: 10px;

        .el-input {
          width: 170px;
          margin-right: 10px;

          .el-input__inner {
            line-height: 36px;
            height: 36px;
          }
        }
      }

      .el-radio.is-checked .el-radio__input.is-checked .el-radio__inner {
        border-color: #42bced;
        background: #42bced;
      }

      .el-radio.is-checked .el-radio__label {
        color: #147dd9 !important;
      }
    }

  }

  .formBox {
    .el-form-item {
      .content-panel {
        line-height: 40px;

        &>.el-checkbox {
          line-height: 50px;
        }
      }

      .privilege-form-item {
        padding: 0 10px;
      }
    }

  }

  .contentShowArea {
    // position: absolute;
    // top: 36px;
    // bottom: 0;
    // left: 0;
    // right: 0;
    // padding: 10px;

    // .el-table__header-wrapper {
    //   tr {
    //     background: #f8f8f8;

    //     th {
    //       background: #f8f8f8;
    //       border-bottom: 2px solid rgba(46, 91, 255, 0.5);
    //       color: #333333;
    //       padding: 10px 0;

    //       .cell {
    //         // font-weight: bold;
    //         font-family: PingFangBold;

    //         .caret-wrapper {
    //           height: 29px;

    //           .ascending {
    //             top: 3px;
    //           }

    //           .descending {
    //             bottom: 5px;
    //           }
    //         }
    //       }
    //     }
    //   }
    // }

    // .el-table__body-wrapper {
    //   tbody {
    //     tr {
    //       td {
    //         border: none;
    //         padding: 9px 0;

    //         .cell {
    //           color: #333;
    //         }
    //       }
    //     }
    //   }
    // }

    .el-table__fixed-right {
      &::before {
        display: none;
      }

      // .el-table__fixed-header-wrapper {
      //   tr {
      //     background: #f8f8f8;

      //     th {
      //       background: #f8f8f8;
      //       border-bottom: 2px solid rgba(46, 91, 255, 0.5);
      //       color: #333333;
      //       padding: 10px 0;

      //       .cell {
      //         // font-weight: bold;
      //         font-family: PingFangBold;

      //         .caret-wrapper {
      //           height: 29px;

      //           .ascending {
      //             top: 3px;
      //           }

      //           .descending {
      //             bottom: 5px;
      //           }
      //         }
      //       }
      //     }
      //   }
      // }

      .el-table__fixed-body-wrapper {
        tbody {
          tr {
            td {
              // border: none;
              // padding: 9px 0;

              .cell {
                text-align: center;

                .editBtn {
                  color: #28c6a2;
                }

                .delBtn {
                  color: #dd3071;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
